import React, { Component } from "react";
import PropTypes from "prop-types";
import Counter from "./Counter";
import Toggle from "material-ui/Toggle";
import { DivRow } from "./styled";

function cssToJS(str) {
  const lines = str.split("px").filter(line => line.trim());
  const myKey = ["top", "right", "bottom", "left"];
  const result = {};

  if (lines.length === 1) {
    for (let i = 0; i < myKey.length; i++) {
      const key = myKey[i];
      result[key] = !isNaN(lines[0]) ? lines[0] * 1 : 0;
    }
  } else {
    for (let i = 0; i < myKey.length; i++) {
      const key = myKey[i];
      if (i < lines.length) {
        result[key] = !isNaN(lines[i]) ? lines[i] * 1 : 0;
      } else {
        result[key] = 0;
      }
    }
  }
  return result;
}

function getSize(str) {
  const lines = str.split("px").filter(line => line.trim());
  return lines.length > 1 ? true : false;
}

function setValue(top, right, bottom, left) {
  let padding = top + "px " + right + "px " + bottom + "px " + left + "px";
  return padding;
}

class BlockCounter extends Component {
  constructor(props) {
    super(props);
    const { containerPadding } = props;
    const padding = cssToJS(containerPadding);
    const count = getSize(containerPadding);
    let changeNumber = 0;
    if (!count) {
      changeNumber = containerPadding.split("px").join("") * 1;
    }
    this.state = {
      allSide: changeNumber,
      top: padding.top,
      left: padding.left,
      right: padding.right,
      bottom: padding.bottom,
      isAllSide: count
    };
  }

  onSetValue = (key, value) => {
    if (this.state.isAllSide) {
      let padding = setValue(
        this.state.top,
        this.state.right,
        this.state.bottom,
        this.state.left
      );
      switch (key) {
        case "top":
          this.setState({ top: value });
          padding = setValue(
            value,
            this.state.right,
            this.state.bottom,
            this.state.left
          );
          break;
        case "bottom":
          this.setState({ bottom: value });
          padding = setValue(
            this.state.top,
            this.state.right,
            value,
            this.state.left
          );
          break;
        case "right":
          this.setState({ right: value });
          padding = setValue(
            this.state.top,
            value,
            this.state.bottom,
            this.state.left
          );
          break;
        case "left":
          this.setState({ left: value });
          padding = setValue(
            this.state.top,
            this.state.right,
            this.state.bottom,
            value
          );
          break;
        default:
          break;
      }
      console.log(padding);
      this.props.onUpdatePadding(padding);
    } else {
      this.setState({
        allSide: value,
        top: value,
        bottom: value,
        right: value,
        left: value
      });
      console.log(value);
      this.props.onUpdatePadding(value + "px");
    }
  };

  onToggle = (e, v) => {
    // console.log(this.state.allSide);
    if (v) {
      let padding = setValue(
        this.state.top,
        this.state.right,
        this.state.bottom,
        this.state.right
      );
      this.props.onUpdatePadding(padding);
    } else {
      this.props.onUpdatePadding(this.state.allSide + "px");
    }
    this.setState({ isAllSide: v });
  };

  componentWillReceiveProps(nextProps) {
    const { containerPadding } = nextProps;
    if (containerPadding !== this.props.containerPadding) {
      const padding = cssToJS(containerPadding);
      const count = getSize(containerPadding);
      let changeNumber = 0;
      if (!count) {
        changeNumber = containerPadding.split("px").join("") * 1;
      }
      this.setState({
        allSide: changeNumber,
        top: padding.top,
        left: padding.left,
        right: padding.right,
        bottom: padding.bottom,
        isAllSide: count
      });
    }
  }

  render() {
    return (
      <div>
        <Toggle
          label="More Options"
          style={{ marginBottom: 10 }}
          toggled={this.state.isAllSide}
          onToggle={(e, v) => this.onToggle(e, v)}
        />
        {!this.state.isAllSide && (
          <div>
            <Counter
              title="All Side"
              onSetValue={value => this.onSetValue("AllSide", value)}
              value={this.state.allSide}
            />
          </div>
        )}
        {this.state.isAllSide && (
          <div>
            <DivRow>
              <Counter
                title="Top"
                onSetValue={value => this.onSetValue("top", value)}
                value={this.state.top}
              />
              <Counter
                title="Right"
                onSetValue={value => this.onSetValue("right", value)}
                value={this.state.right}
              />
            </DivRow>
            <DivRow>
              <Counter
                title="Left"
                onSetValue={value => this.onSetValue("left", value)}
                value={this.state.left}
              />
              <Counter
                title="Bottom"
                onSetValue={value => this.onSetValue("bottom", value)}
                value={this.state.bottom}
              />
            </DivRow>
          </div>
        )}
      </div>
    );
  }
}

BlockCounter.propTypes = {
  containerPadding: PropTypes.string,
  onUpdatePadding: PropTypes.func.isRequired
};

BlockCounter.defaultProps = {
  containerPadding: "20px"
};

export default BlockCounter;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/components/counter/BlockCounter.js